import { render, staticRenderFns } from "./UrunTanimla.vue?vue&type=template&id=d16338c0&scoped=true&"
import script from "./UrunTanimla.vue?vue&type=script&lang=js&"
export * from "./UrunTanimla.vue?vue&type=script&lang=js&"
import style1 from "./UrunTanimla.vue?vue&type=style&index=1&id=d16338c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16338c0",
  null
  
)

export default component.exports